<script>
  import GanttTable from "./components/GanttTable.svelte";
  import GanttNavi from "./components/GanttNavi.svelte";
  import { apiStoreGET } from "./api";
  import { startOfYear, endOfYear, getYear, addYears } from "date-fns";
  import deDeLocale from "date-fns/locale/de";
  import { setContext } from "svelte";
  import { getContext } from 'svelte';

  export let centerDate = new Date(Date.now());
  const objecturl = getContext("objecturl");

  let searchurl = new URL(objecturl);
  searchurl.search = new URLSearchParams("sort_on=start&sort_order=ascending&metadata_fields=start&metadata_fields=end&metadata_fields=Subject&metadata_fields=UID&metadata_fields=termin_art").toString();
  const searchurlString = searchurl.toString();
  let currentYearStartDate;
  let currentYearEndDate;
  let currentYearNumber;
  let eventsResponse = apiStoreGET(searchurlString);

  let primaryBackgroundColor = "#B0E6CE";
  let primaryFontColor = "#27664A";
  let secondaryBackgroundColor = "#FFA963";
  let secondaryAlternativeBackgroundColor = "#FED8C3";
  let secondaryFontColor = "#4B2609";

  let zoomLevels = {
    0: {
      primaryScale: 365,
      primaryHeaders: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
    },
  };

  $: {
    currentYearNumber = getYear(centerDate, { locale: deDeLocale });
    currentYearStartDate = startOfYear(centerDate, {
      locale: deDeLocale,
    });
    currentYearEndDate = endOfYear(centerDate, { locale: deDeLocale });

    eventsResponse = apiStoreGET(searchurlString);
  }

  function previous(e) {
    centerDate = addYears(centerDate, -1);
  }

  function now(e) {
    centerDate = addYears(new Date(Date.now()), 0);
  }

  function next(e) {
    centerDate = addYears(centerDate, 1);
  }

  setContext("previous", previous);
  setContext("next", next);
  setContext("now", now);
</script>

<!--<svelte:options tag="gantt-chart" /> -->

<div class="svelte-app-wrapper">
  {#await $eventsResponse}
    loading ...
  {:then data}
    <div class="Gantt">
      <GanttNavi gantttitle={currentYearNumber} />
      <GanttTable
        items={data.items}
        tableStartDate={currentYearStartDate}
        tableEndDate={currentYearEndDate}
        {zoomLevels}
        ganttMode="monthly"
        categoryField="termin_art"
      />
    </div>
  {/await}
</div>

<style>
</style>
